import agentHandlers from './agent';
import auditHandlers from './audit';
import authTokenHandlers from './authTokens';
import billingHandlers from './billing';
import clusterActionsHandlers from './clusterActions';
import clusterAutoscalerHandlers from './clusterAutoscaler';
import clusterRebalancingHandlers from './clusterRebalancing';
import clusterHandlers from './clusters';
import costReportHandlers from './costReports';
import credentialHandlers from './credentials';
import dashboardMetricsHandlers from './dashboardMetrics';
import externalClusterHandlers from './externalClusters';
import notificationHandlers from './notifications';
import organizationHandlers from './organization';
import regionsHandlers from './regions';
import reportsHandlers from './reports';
import usersHandlers from './users';

const handlers = [
  ...agentHandlers,
  ...auditHandlers,
  ...authTokenHandlers,
  ...billingHandlers,
  ...clusterActionsHandlers,
  ...clusterAutoscalerHandlers,
  ...clusterRebalancingHandlers,
  ...clusterHandlers,
  ...costReportHandlers,
  ...credentialHandlers,
  ...dashboardMetricsHandlers,
  ...externalClusterHandlers,
  ...notificationHandlers,
  ...organizationHandlers,
  ...regionsHandlers,
  ...reportsHandlers,
  ...usersHandlers,
];

export default handlers;
